import * as React from 'react';

function SvgComponent(props, ref) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 473.931 473.931" {...props} ref={ref}>
      <circle cx={236.966} cy={236.966} r={236.966} fill="#d7daba" />
      <path
        d="M354.154 359.291a6.538 6.538 0 01-6.537 6.541H127.908a6.537 6.537 0 01-6.537-6.541V101.937a6.542 6.542 0 016.537-6.541h219.709a6.542 6.542 0 016.537 6.541v257.354z"
        fill="#327477"
      />
      <path
        d="M354.154 376.967a6.539 6.539 0 01-6.537 6.537H140.282V140.555h207.331a6.542 6.542 0 016.537 6.541v229.871h.004z"
        fill="#3b7f89"
      />
      <path fill="#4699a1" d="M137.633 137.158h3.977v246.35h-3.977z" />
      <path
        d="M138.292 95.396h-10.383a6.542 6.542 0 00-6.537 6.541v275.031a6.539 6.539 0 006.537 6.537h10.383V95.396z"
        fill="#2a646e"
      />
      <path
        d="M342.371 140.473H143.706c-6.773 0-12.262-5.497-12.262-12.269v-8.056c0-6.773 5.489-12.262 12.262-12.262h186.403c6.773 0 12.262 5.493 12.262 12.262v20.325z"
        fill="#e9e9ea"
      />
      <g fill="#2a646e">
        <path d="M284.46 251.574h-73.503c-8.677 0-15.734-7.061-15.734-15.734v-38.147c0-8.67 7.057-15.73 15.734-15.73h73.503c8.673 0 15.734 7.061 15.734 15.73v38.143c-.004 8.677-7.061 15.738-15.734 15.738zM309.683 290.84c0 2.821-2.196 5.111-4.909 5.111H188.443c-2.713 0-4.913-2.29-4.913-5.111 0-2.829 2.2-5.115 4.913-5.115h116.331c2.716 0 4.909 2.286 4.909 5.115zM309.683 309.81c0 2.821-2.196 5.111-4.909 5.111H188.443c-2.713 0-4.913-2.29-4.913-5.111 0-2.821 2.2-5.111 4.913-5.111h116.331c2.716 0 4.909 2.29 4.909 5.111zM289.017 338.031c0 1.893-1.482 3.435-3.304 3.435h-78.21c-1.826 0-3.304-1.542-3.304-3.435 0-1.897 1.482-3.439 3.304-3.439h78.21c1.826 0 3.304 1.542 3.304 3.439z" />
      </g>
    </svg>
  );
}
const BookTitleIcon = React.forwardRef(SvgComponent);
export default BookTitleIcon;
